import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Bug } from "lucide-react";
import { BugReportDialog } from "./BugReportDialog";

export function BugReportButton() {
    const { t } = useTranslation("bugReports");
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                title={t("buttonTooltip")}
                className="fixed bottom-4 right-4 z-50 flex items-center justify-center w-8 h-8 rounded-full bg-muted/80 hover:bg-muted border border-border/60 text-muted-foreground hover:text-foreground shadow-sm backdrop-blur-sm transition-all hover:shadow-md"
            >
                <Bug className="w-3.5 h-3.5" />
            </button>
            <BugReportDialog open={open} onOpenChange={setOpen} />
        </>
    );
}
